import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Spinner from "../components/shared/Common/spinner";
import store from "../reducers/store";
import SharedUtils from "../components/shared/Common/utils";

const Detection = lazy(() => import("../components/Pages/Events/event"));
const Restriction = lazy(() => import("../components/Pages/Restrictions/restriction"));
const Audit = lazy(() => import("../components/Pages/Logs/audit"));
const OverView = lazy(() => import("../components/Pages/OverView/overView"));
const Certificates = lazy(() => import("../components/Pages/Certificate/certificates"));
const Installers = lazy(() => import("../components/Pages/Installers/installers"));
const Policy = lazy(() => import("../components/Pages/Policy/policy"));
const Browser = lazy(() => import("../components/Pages/Policy/browser"));
const Login = lazy(() => import("../components/Pages/Login/login"));
const Ldap = lazy(() => import("../components/Pages/Config/Ldap/ldap"));
const Siem = lazy(() => import("../components/Pages/Config/Siem/siem"));
const Sso = lazy(() => import("../components/Pages/Config/Sso/sso"));
const Pac = lazy(() => import("../components/Pages/Config/Pac/pac"));
const Brand = lazy(() => import("../components/Pages/Config/Brand/brand"));
const Admins = lazy(() => import("../components/Pages/Config/Admins/admins"));
const Users = lazy(() => import("../components/Pages/Users/users"));
const Visibility = lazy(() => import("../components/Pages/Visibility/saas"));
const Extensions = lazy(() => import("../components/Pages/Visibility/ext"));
const Traffic = lazy(() => import("../components/Pages/Traffic/traffic"));

class AppRoutes extends Component {
    render() {
        return (
            <Suspense fallback={Spinner}>
                <Switch>
                    {<Route exact path="/overview" component={OverView} />}
                    {<Route exact path="/events/detection" component={Detection} />}
                    {<Route exact path="/events/restriction" component={Restriction} />}
                    {<Route exact path="/certificates" component={Certificates} />}
                    {<Route exact path="/policy" component={Policy} />}
                    {<Route exact path="/policy/proxy" component={Policy} />}
                    {<Route exact path="/policy/appcontrol" component={Policy} />}
                    {<Route exact path="/policy/ignoreurl" component={Policy} />}
                    {<Route exact path="/policy/blockurl" component={Policy} />}
                    {<Route exact path="/policy/urlfilter" component={Policy} />}
                    {<Route exact path="/policy/filescan" component={Policy} />}
                    {<Route exact path="/policy/dlp" component={Policy} />}
                    {<Route exact path="/policy/ext" component={Policy} />}
                    {!window.config.ff_fullpanel && <Route exact path="/policy/browser_pr" component={Browser} />}
                    {<Route exact path="/policy/browser" component={Policy} />}
                    {<Route exact path="/policy/awareness" component={Policy} />}
                    {<Route exact path="/license/users" component={Users} />}
                    {<Route exact path="/config/ldap" component={Ldap} />}
                    {<Route exact path="/config/siem" component={Siem} />}
                    {<Route exact path="/config/sso" component={Sso} />}
                    {<Route exact path="/license/installers" component={Installers} />}
                    {<Route exact path="/config/pac" component={Pac} />}
                    {<Route exact path="/config/brand" component={Brand} />}
                    {<Route exact path="/config/admins" component={Admins} />}
                    {<Route exact path="/visibility/saas" component={Visibility} />}
                    {<Route exact path="/visibility/traffic" component={Traffic} />}
                    {<Route exact path="/visibility/ext" component={Extensions} />}
                    {<Route exact path="/logs/audit" component={Audit} />}

                    {<Route exact path="/" component={OverView} />}
                    {<Route exact path="/login" component={Login} />}

                {/*    <Redirect to="/login" />*/}
                </Switch>
            </Suspense>
        );
    }
}

export default AppRoutes;
